import { getTabId } from '@prophecy/utils/session';
import queryString from 'query-string';

export const TAB_ID_HEADER = 'X-Tab-Id';

/** For WebSocket handshakes and cross-origin calls, where a custom header would need a preflight. */
export const TAB_ID_QUERY_KEY = 'tabId';

export function addTabIdQuery(url: string) {
  const tabIdQuery = queryString.stringify({ [TAB_ID_QUERY_KEY]: getTabId() });
  return url.includes('?') ? `${url}&${tabIdQuery}` : `${url}?${tabIdQuery}`;
}
